import { FDRStatus } from '@cibo/core'
import {
  AuthUserPermission,
  PaginatedOrgsTable,
  useFDRAcresColumn,
  useFDRFieldCountColumn,
  useOrgColumns,
  useOrganizationList,
  usePermissions,
  useWindowTitle,
} from '@cibo/profile'
import { LayoutSection } from 'components/ImpactLayout'
import { ADMIN_ROUTES } from 'navigation/types'
import { Forbidden } from 'pages/Forbidden'
import { useTranslation } from 'react-i18next'
import { Navigate, generatePath, useNavigate } from 'react-router-dom'
import { FDRRollups } from '../FDRRollups'

export const OrganizationList = () => {
  const { t } = useTranslation('impact/OrgList')
  useWindowTitle(t('pageTitle'))
  const navigate = useNavigate()
  const { can } = usePermissions()
  const organizations = useOrganizationList()

  const { name, userCount, registeredUserCount, fieldCount, acres } = useOrgColumns()

  const fdrColumns = [
    useFDRFieldCountColumn(FDRStatus.enrolling),
    useFDRAcresColumn(FDRStatus.enrolling),
    useFDRFieldCountColumn(FDRStatus.enrolled),
    useFDRAcresColumn(FDRStatus.enrolled),
  ]

  if (!can({ useAny: AuthUserPermission.ORG_DASHBOARD })) {
    return <Forbidden returnTo={'/'} />
  }
  if (!organizations.data?.length) {
    return <Navigate to={ADMIN_ROUTES.ROOT} replace />
  }

  return (
    <LayoutSection sx={{ flex: 1 }}>
      <FDRRollups />

      <PaginatedOrgsTable
        columns={[name, userCount, registeredUserCount, ...fdrColumns, fieldCount, acres]}
        headerPaletteColor="primary"
        onRowClick={({ id }) =>
          navigate(generatePath(ADMIN_ROUTES.ORGANIZATION_DETAIL, { organizationId: id as string }))
        }
      />
    </LayoutSection>
  )
}
